<template>
  <span ref="component">
    <iframe
      v-if="videoId"
      id="existing-iframe-example"
      allowfullscreen=""
      frameborder="0"
      :height="dataHeight"
      :width="dataWidth"
      :src="`//www.youtube.com/embed/${videoId}?enablejsapi=1&amp;rel=0`"></iframe>
  </span>
</template>

<script>
  import $ from 'jquery';

  export default {
    props: {
      dataWidth: {default: 640},
      dataHeight: {default: 360},
      dataVideo: {default: null},
    },
    data () {
      return {
        videoLength: 0,
        currentLength: 0,
        player: null,
        input: null,
      }
    },
    computed: {
      videoId () {
        return this.dataVideo;
      }
    },
    mounted () {
      console.log([
        this.dataWidth,
        this.dataHeight,
        this.dataVideo,
      ])
      if (this.dataVideo) {
        const vueComponent = $(this.$refs.component);
        const questionContainer = vueComponent.closest('.question-container');
        this.input = $('.form-control', questionContainer);

        window.setInterval(() => {
          if (this.player) {
            this.currentLength = Math.max(this.currentLength, this.player.getCurrentTime());
          }
        }, 1000);
        const self = this;
        $(function () {
          window.onYouTubeIframeAPIReady = () => {
            self.player = new YT.Player('existing-iframe-example', {
              playerVars: {
                autoplay: 0,
                controls: 1,
                autohide: 1,
                wmode: 'opaque',
                showinfo: 0,
              },
              events: {
                onReady: self.onPlayerReady,
                onStateChange: self.onPlayerStateChange
              }
            });
          }

          var tag = document.createElement('script');
          tag.id = 'iframe-demo';
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[ 0 ];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        })
      }
    },
    methods: {
      onPlayerReady (event) {
        console.log({player: this.player});
        this.videoLength = this.player.getDuration();
      },
      onPlayerStateChange (event) {
        if (this.player) {
          this.currentLength = Math.max(this.currentLength, this.player.getCurrentTime());
        }
      },
    },
    watch: {
      currentLength (val) {
        const percentage = this.videoLength > 0
          ? Math.round(val / this.videoLength * 100)
          : 0;
        console.log({val, percentage, videoLength: this.videoLength});
        this.input.val(percentage);
      }
    },
    components: {}
  }
</script>
